commusoftCommon.directive('csdeletewarningmodal', ['prefix', '$http', '$modal', function(prefix, $http, $modal) {
    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            title: '@',
            shouldBeOpen: '='
        },
        controller: function($scope, $element, $attrs, $transclude) {
            $scope.$watch('shouldBeOpen', function(newVal, oldVal, scope) {
                var modalInstance = null;
                if (newVal) {
                    var elem = $transclude($scope, function() {});
                    $scope.transData = elem;

                    modalInstance = $modal.open({
                        templateUrl: 'template/delete_warning_modal.html',
                        scope: $scope,
                        controller: CSDeleteModalCtrl,
                        windowClass: 'warning-modal'
                    })
                }
            });
        }
    }
}]);